import {
  AttendanceSettingCreateVersionDocument,
  AttendanceSettingCreateVersionMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateAttendanceVersion = () => {
  const [createAttendanceSettingVersion, { loading }] = useMutation(
    AttendanceSettingCreateVersionDocument,
    {
      extractorFn: (data) => data.attendanceMutations.createVersionAttendanceEmployeesSetting,
    }
  )

  const create = (variables: AttendanceSettingCreateVersionMutationVariables) => {
    return createAttendanceSettingVersion({
      variables,
    })
  }

  return {
    loading,
    create,
  }
}
